import { useEffect, useState } from "react";
import { MagnifyingGlass, X, Heart } from "@phosphor-icons/react";
import { accountService } from "../../services/accountService";

export default function PartnerSearch({ current, onLink, onUnlink }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    let active = true;
    if (!query.trim()) {
      setResults([]);
      return;
    }
    setSearching(true);
    const t = setTimeout(async () => {
      const res = await accountService.searchPartner(query);
      if (active) {
        setResults(res);
        setSearching(false);
      }
    }, 220);
    return () => {
      active = false;
      clearTimeout(t);
    };
  }, [query]);

  return (
    <div className="space-y-3" data-testid="partner-search">
      {current ? (
        <div className="flex items-center justify-between rounded-xl border border-[rgba(184,50,90,0.45)] bg-[rgba(139,30,63,0.18)] px-4 py-3">
          <div className="flex items-center gap-2 text-sm text-[#e9b5c5]">
            <Heart size={14} weight="fill" /> Vinculado con <strong className="text-[#f5f5f5]">{current}</strong>
          </div>
          <button
            type="button"
            onClick={onUnlink}
            className="flex items-center gap-1 text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.65)] hover:text-[#f5f5f5]"
            data-testid="partner-unlink-button"
          >
            <X size={12} /> Desvincular
          </button>
        </div>
      ) : (
        <>
          <label className="zx-label">Buscar pareja por nick</label>
          <div className="relative">
            <MagnifyingGlass
              size={14}
              weight="thin"
              className="absolute left-0 top-1/2 -translate-y-1/2"
            />
            <input
              className="zx-input pl-6"
              placeholder="Empieza a escribir..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              data-testid="partner-search-input"
            />
          </div>

          {query && (
            <div className="zx-card max-h-64 overflow-auto p-2" data-testid="partner-results">
              {searching ? (
                <p className="p-3 text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.5)]">
                  Buscando...
                </p>
              ) : results.length === 0 ? (
                <p className="p-3 text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.5)]">
                  Sin resultados
                </p>
              ) : (
                results.map((u) => (
                  <button
                    key={u.id}
                    type="button"
                    onClick={() => onLink(u)}
                    className="flex w-full items-center justify-between rounded-lg px-3 py-2 text-left text-sm text-[#f5f5f5] hover:bg-[rgba(255,255,255,0.04)]"
                    data-testid={`partner-result-${u.id}`}
                  >
                    <span>{u.nick}</span>
                    <span className="zx-tag">Vincular →</span>
                  </button>
                ))
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
